import React from 'react';
import ReactDOM from 'react-dom/client';

import '@link/shinkansen/i18n';
import '@link/shinkansen/styles/index.css';
import App from '@link/shinkansen/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
